import styled from "styled-components";
import { Link } from "react-router-dom";
import { tokens } from "../../../../../public/tokens";

const { colors, globals } = tokens;

/** `flex-start` keeps the status pill content-width instead of stretching to the cell's width. */
export const StyledPortalNameStack = styled.div({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: globals["spacing-1"],
});

export const StyledPrereqLink = styled(Link)({
    color: colors.text.primary,
    textDecoration: "none",

    "&:hover": {
        color: colors.text.primary,
        textDecoration: "underline",
    },
});
